export default __webpack_public_path__ + "static/media/DanskeNarrow-Italic.7d1dc0df.svg";